import { EuiContextMenu, EuiHeader, EuiHeaderLink, EuiHeaderLinks, EuiHeaderSectionItem, EuiHeaderSectionItemButton, EuiIcon, EuiPopover, htmlIdGenerator } from '@elastic/eui';
import React, { useCallback, useMemo, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { useUserSettings } from '../../context/CurrentUserContext';
import * as AuthenticationProvider from "../../modules/AuthenticationProvider";
import { navigationType } from './interfaces';
import { LinkUser } from './LinkUser';
import reactSvg from "./L_ROYT.png";
import './style.css';

const Navigation = (props: any) => {
  let {currentUser} = useUserSettings() as any;

  const menuItems: Array<navigationType> = [
      {
        id: 0,
        key: "informes",
        name: "Informes",
        title: "Informes Periodo Cerrado",
        to: "/Informes",
        items: [
          {
            key: "seleccionInformes",
            name: "Selección de Informes",
            title: "SeleccionInformes",
            to: "/Informes/SeleccionInformes",
            items: []
          },
          {
            key: "seleccionInformesExcel",
            name: "Selección de Informes Excel",
            title: "seleccionInformesExcel",
            to: "/Informes/seleccionInformesExcel",
            // perfil: ['CORP','CG','IT'],
            items: []
          }
        ]
      },
      {
        id: 0,
        key: "GestionDNs",
        name: "Gestion DNs",
        title: "Periodo Abierto",
        to: "/GestionDNs",
        excludeperfil : ['DIR'],
        items: [
          {
            key: "descargar",
            name: "Descargar Plantilla",
            title: "Descargar Plantilla",
            to: "/GestionDNs/DescargarPlantilla",
            excludeperfil : ['DEL_CONSULTA','DN_CONSULTA','CORP'],
            items: []
          },
          {
            key: "subir",
            name: "Subir Fichero",
            title: "Subir Fichero",
            to: "/GestionDNs/SubirFichero",
            excludeperfil : ['DEL_CONSULTA','DN_CONSULTA','CORP'],
            items: []
          },
          {
            key: "AccesoInformaciónSubida",
            name: "Acceso a Información Subida",
            title: "Acceso a Información Subida",
            to: "/GestionDNs/AccesoInformaciónSubida",
            excludeperfil : ['DEL_CONSULTA','DN_CONSULTA','CORP'],
            items: []
          },
          {
            key: "InformesPeriodoAbierto",
            name: "Informes del Periodo Abierto",
            to: "/GestionDNs/InformesPeriodoAbierto",
            items: []
          },
          {
            key: "InformesExcelPeriodoAbierto",
            name: "Selección de Informes Excel",
            title: "InformesExcelPeriodoAbierto",
            to: "/GestionDNs/seleccionInformesExcel",
            // perfil: ['CORP','CG','IT'],
            items: []
          },
          {
            key: "ValidacionDN",
            name: "Validación",
            to: "/GestionDNs/ValidacionDN",
            excludeperfil : ['DEL_CONSULTA','DN_CONSULTA','CORP'],
            // excludeperfil : ['DEL_CARGA'],
            items: []
          },
          // {
          //   key: "ConsultarEstadoCargas",
          //   name: "Consultar Estado de las Cargas",
          //   title: "Consultar Estado de las Cargas",
          //   to: "/GestionDNs/ConsultarEstadoCargas",
          //   excludeperfil : ['DN_ADMON','DEL_CARGA'],
          //   items: []
          // },
          // {
          //   key: "ValidacionCG",
          //   name: "Validación CG",
          //   to: "/GestionDNs/ValidacionCG",
          //   excludeperfil : ['DN_ADMON','DEL_CARGA'],
          //   items: []
          // },
          {
            key: "ConsultarLog",
            name: "Consultar Log",
            title: "Consultar Log",
            to: "/GestionDNs/ConsultarLog",
            excludeperfil : ['DEL_CONSULTA','DN_CONSULTA','CORP','DEL_CARGA'],
            items: []
          },
          {
            key: "logimport",
            name: "Log Importaciones Fichero",
            title: "Log Importaciones Fichero",
            to: "/GestionDNs/LogImportaciones",
            excludeperfil : ['DEL_CONSULTA','DN_CONSULTA','CORP'],
            // excludeperfil : ['DN_ADMON','DEL_CARGA'],
            items: []
          }
        ]
      },
      {
        id: 0,
        key: "consultas",
        name: "Consultas",
        title: "Consultas",
        to: "/Consultas",
        items: [
          {
            key: "paises",
            name: "Paises (GIAS)",
            title: "Paises",
            to: "/Consultas/Paises",
            items: []
          },
          {
            key: "sumarigrama",
            name: "Sumarigrama (GIAS)",
            title: "Sumarigrama",
            to: "/Consultas/Sumarigrama",
            items: []
        },
          {
            key: "tiposCambio",
            name: "Tipos de Cambio",
            title: "TiposCambio",
            to: "/Consultas/TiposCambio",
            items: []
          }
        ]
      },
      {
        id: 0,
        key: "configuracion",
        name: "Configuración",
        title: "Configuración",
        to: "/Configuracion",
        perfil : ['IT','CG'],
        items: [
          {
            key: "auxiliares",
            name: "Auxiliares",
            title: "Auxiliares",
            to: "/Configuracion/Auxiliares",
            items: []
          },
          {
            key: "periodos",
            name: "Periodos",
            title: "Periodos",
            to: "/Configuracion/Periodos",
            items: []
          },
          {
            key: "usuarios",
            name: "Usuarios",
            title: "Usuarios",
            to: "/Configuracion/Usuarios",
            items: []
          },
          {
            key: "validaciones",
            name: "Validaciones",
            title: "Validaciones",
            to: "/Configuracion/Validaciones",
            items: []
          },
          {
            key: "contenidoInformes",
            name: "Contenido de Informes",
            title: "ContenidoDeInformes",
            to: "/Configuracion/ContenidoInformes",
            items: []
          },
        ]
      }
    ];

    let [activeItem, setActiveItem] = useState(menuItems[0].name);

    const filtraMenuPermisos = useCallback((menuItems: Array<navigationType>, perfil: string) => {

      const filterData = (arr:any) => {
        return arr.reduce(
          (acc:any, item:any) => {
            const newItem:navigationType = item;
      
            if (item.items) {
              newItem.items = filterData(item.items);
            }
            if ((newItem.excludeperfil === undefined || (newItem.excludeperfil !== undefined && !newItem.excludeperfil.includes(perfil))) 
              && (newItem.perfil === undefined || (newItem.perfil !== undefined && newItem.perfil.includes(perfil))))
            {
              acc.push(newItem);
            }
            
            return acc;
          },
          []
        );
      }

      return filterData(menuItems)
     
    },[])

    const doNavigation = useCallback((newLocation: any) => {
        props.history.push(newLocation);
    },[props.history])

    const createNewLocation = useCallback((path: any) => {
        const currentLocation = props.location;
        return {
          pathname: path,
          state: {
            from:
              currentLocation && currentLocation.pathname
                ? currentLocation.pathname
                : "/nofound",
          },
        };
      },[props.location])

      const handleItemClicked = useCallback((event: any, data: any) => {
        
        if (data.to) {
          doNavigation(createNewLocation(data.to));
          setActiveItem(data.name);
        } else {
          switch (data.name.toLowerCase()) {
            case "logout":
              AuthenticationProvider.doLogout(() => {
                doNavigation(createNewLocation("/login"));
              });
              break;
          }
        }
        return;
      },[createNewLocation, doNavigation])

      const getIconMenu = useMemo(() =>{
        return (
          <EuiHeaderSectionItem>
            <EuiIcon type={reactSvg} size="xl" title="Elecnor" className="menuIcon" id="elecnor-icon"/>
          </EuiHeaderSectionItem>
        )
      },[])

      const getLinksMenu = useMemo(() =>{
        return(
          <EuiHeaderLinks aria-label="App navigation dark theme example">
            {filtraMenuPermisos(menuItems, currentUser.perfil).map((item:navigationType, key:number) => (
                (item.items && item.items.length > 0) ?
                <HeaderAppMenu data={item} handleItemClicked={handleItemClicked}/>
                : 
                <EuiHeaderLink key={key} onClick={()=> {handleItemClicked('', item)}} isActive={activeItem === item.name}>{item.title}</EuiHeaderLink>
                
              ))}
          </EuiHeaderLinks>
        )
      },[menuItems,currentUser.perfil, activeItem, handleItemClicked,filtraMenuPermisos]);
      //[menuItems, currentUser.perfil, activeItem, handleItemClicked, filtraMenuPermisos]);

      const getUserDataMenu = useMemo(() =>{
        return <LinkUser user={currentUser} handleExit={handleItemClicked} exitParams={{name:"logout"}}/>
       },[currentUser, handleItemClicked])

       return(
        <EuiHeader theme="dark" sections={[
            {
              items: [
                getIconMenu,
                getLinksMenu
              ]},
              {
                items: [
                  getUserDataMenu
                ]
              }
          ]}
        />        
      );
}

const HeaderAppMenu = (props: any) => {
    const idGenerator = htmlIdGenerator();
    const popoverId = idGenerator('popover');
    const keypadId = idGenerator('keypad');
  
    const [isOpen, setIsOpen] = useState(false);
  
    const onMenuButtonClick = useCallback(() => {
      setIsOpen(!isOpen);
    },[isOpen])
  
    const closeMenu = () => {
      setIsOpen(false);
    };
  
    const button = useMemo(() =>{
      return(
        <EuiHeaderSectionItemButton
          aria-controls={keypadId}
          aria-expanded={isOpen}
          aria-haspopup="true"
          //onMouseOver={onMenuButtonClick}
          onClick={onMenuButtonClick}
          >
          <EuiHeaderLink key={112} >{props.data.title}</EuiHeaderLink>
        </EuiHeaderSectionItemButton>
      )
      },[keypadId,isOpen, onMenuButtonClick, props.data])

    const getPanels = useMemo(() =>{
      const data = {...props.data}

      let newItems = data.items.map((d:any)=>{
        let link = {onClick:()=> {closeMenu();props.handleItemClicked("",d)}}
        return {...d,...link}
      })
      data.items = [...newItems];
      return [data];
    },[props])
  
    return (
      <EuiPopover
        id={popoverId}
        ownFocus
        button={button}
        isOpen={isOpen}
        anchorPosition="downRight"
        panelStyle={{padding: "1px"}}
        closePopover={closeMenu}>
        <EuiContextMenu initialPanelId={0} panels={getPanels}/>
      </EuiPopover>
    );
  }
  
export const GlobalNavigation = withRouter(Navigation);